/**
 * Created by iamso on 07.10.2021
 */

const MicrosoftSender = function () {
    BaseSender.call(this);

    this.config = {
        maxTimeout: 30
    };
};

MicrosoftSender.prototype = Object.create(BaseSender.prototype);
MicrosoftSender.prototype.constructor = MicrosoftSender;

MicrosoftSender.prototype.send = function (data, timeout) {
    const title = data.title;
    const message = data.message;

    const id = data.id;

    if (!message) {
        connector.notifications.trigger("stream:error", `empty microsoft push - ${data.code}`);
        return;
    }

    connector.platform.callNative("localPushes.send", {
        title,
        message,
        timeout,
        id: `${id}`
    });

    return true;
};

MicrosoftSender.prototype.cancel = function (info) {
    console.log(`Cancel push - ${info.code}`);

    connector.platform.callNative("localPushes.cancel", {
        id: `${info.id}`
    });
};

MicrosoftSender.isAppropriate = function () {
    return connector.platform.oneOf(connector.MICROSOFT, connector.G5WINDOWS, connector.MSIX);
};